import { B as BxfLink$1, d as defineCustomElement$1 } from './p-8fb4ef78.js';

const BxfLink = BxfLink$1;
const defineCustomElement = defineCustomElement$1;

export { BxfLink, defineCustomElement };
